<template>
    <router-view></router-view>
</template>

<script>
const supplierNavbarStructure = require("@/structures/supplierNavbarStructure.json");

export default {
  data() {
    return {
      supplierNumber: null,
      navbarStructure: {},
      sidebarRemoved: false,
      supplierMetaData: {},
    };
  },
  created() {
    this.supplierNumber = parseInt(this.$route.params.supplierNumber);
    this.navbarStructure = this.getRestrictedNavStructure(supplierNavbarStructure);
    if (!this.userContainsPermission(["STAFF", "SYSTEM"])) {
      this.sidebarRemoved = true;
    }
  },
  mounted() {
    this.$root.$emit("SET_SUPPLIER_NAVBAR", this.navbarStructure, this.supplierNumber);
  },
  methods: {

    
  },
};
</script>
